'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnpublished = undefined;

var _messageStatusTypes = require('../constants/messageStatusTypes');

var _isStatus = require('./isStatus');

var isUnpublished = exports.isUnpublished = (0, _isStatus.isStatus)(_messageStatusTypes.UNPUBLISHED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isUnpublished.js
// module id = 449
// module chunks = 2 3